import { Box, styled, Theme } from '@mui/material';
import { palette } from 'view/themes/palette';

export const Wrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    height: 'auto',
    width: '100%',
    gap: '24px',
    backgroundColor: palette.background.general,

    [theme.breakpoints.down('tablet')]: {
      padding: 0,
      backgroundColor: palette.white,
      gap: '0px',
    },
  };
});

export const MainContentWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '80%',
    /* position: 'relative', */
    paddingBottom: '24px',
    display: 'flex',
    gap: '24px',
    alignItems: 'flex-start',

    [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '0 16px 32px 16px',
      gap: '32px',
    },
  };
});

export const BreadcrumbsContainer = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '80%',
    minHeight: '30px',
    backgroundColor: palette.white,

    [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
    },
  };
});
